export default __webpack_public_path__ + "static/media/Cloud2s.9dee87fe.svg";